import {BaseService} from './baseService.js';
import {Service} from './service.js';

/**
 * Handles background output
 */
export class BackgroundOutputService extends BaseService {
	
	static get properties() {		
		return {		
		};
	}
	
	constructor() {	
		super();
	}
	
	async getOutputRecords(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}		
		var events = await this.makeGETRequest('/api/resource/background-outputs' + params);
		return events;		
	}
	
	downloadOutput(outputId) {			
		this.downloadFile('/api/resource/background-outputs/' + outputId);		
	};
	
	async deleteOutput(outputId) {		
		var result = await this.makeDELETERequest('/api/resource/background-outputs/' + outputId);		
		return result;
	}	
	
}

